import { createTheme, responsiveFontSizes } from '@mui/material/styles';

// --- CONFIGURAZIONE COMUNE ---
const baseTypography = {
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
};

// --- 1. TEMA MONITOR (Corporate / Light / Cool Tones) ---
// Colori: Blu, Grigio Freddo, Bianco Ghiaccio
let monitorTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0061A4',
      onPrimary: '#FFFFFF',
      primaryContainer: '#D1E4FF',
      onPrimaryContainer: '#001D36',
    },
    secondary: {
      main: '#4F636F',
      onSecondary: '#FFFFFF',
      secondaryContainer: '#D7E3F8',
      onSecondaryContainer: '#101C2B',
    },
    background: {
      default: '#F8F9FA', // Grigio chiarissimo freddo
      paper: '#FFFFFF',
    },
    surface: {
      main: '#FFFFFF',
      onSurface: '#1A1C1E',
      surfaceVariant: '#DFE3EB',
    },
  },
  typography: baseTypography,
  shape: { borderRadius: 12 },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#1A1C1E',
          borderBottom: '1px solid #DFE3EB',
          boxShadow: 'none'
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          border: '1px solid #DFE3EB',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.04)',
        }
      }
    },
  },
});

// --- 2. TEMA TOTEM (Kiosk / Light / Warm Tones) ---
// Colori: Arancione Bruciato, Teal, Crema
let totemTheme = createTheme({
  palette: {
    mode: 'light', // Ora è chiaro
    primary: {
      main: '#D84315', // Arancione scuro intenso (Deep Orange)
      onPrimary: '#FFFFFF',
      primaryContainer: '#FFDBCF', // Arancio pastello molto chiaro
      onPrimaryContainer: '#3E1000',
    },
    secondary: {
      main: '#00695C', // Teal Scuro (per contrasto complementare)
      onSecondary: '#FFFFFF',
      secondaryContainer: '#B2DFDB',
      onSecondaryContainer: '#00201A',
    },
    error: {
      main: '#C62828', // Rosso più caldo
    },
    background: {
      default: '#FFF8E1', // Crema/Beige (Amber 50) - Distingue subito dal monitor
      paper: '#FFFFFF',   // Bianco puro per le card
    },
    text: {
      primary: '#212121', // Nero quasi assoluto per leggibilità massima
      secondary: '#455A64', // Grigio bluastro
    },
    divider: '#FFCCBC', // Divisori colorati leggermente aranciati
  },
  typography: {
    ...baseTypography,
  },
  shape: { borderRadius: 12 }, // Curve molto accentuate per sembrare più "app"
  components: {
    
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20, // Pill shape buttons (molto distintivo)
          boxShadow: '0px 4px 10px rgba(0,0,0,0.1)', // I bottoni sembrano fluttuare
        },
        containedPrimary: {
            '&:hover': {
                backgroundColor: '#BF360C',
            }
        }
      },
      defaultProps: {
        disableElevation: false, // I bottoni Totem hanno elevazione per invitare al tocco
      }
    }
  },
});

monitorTheme = responsiveFontSizes(monitorTheme);
totemTheme = responsiveFontSizes(totemTheme);

export { monitorTheme, totemTheme };